import { inject, Injectable } from '@angular/core';

import { map, Observable, of } from 'rxjs';

import {
  jobBoardRequiresCredentials,
  JobTemplatesJobBoardStoreService,
  OfferJobBoardStoreService,
} from '@recruitee/job-boards-data';
import { JobBoard } from '@recruitee/job-boards-types';
import { JobKind } from '@recruitee/workflow-automations-types';

@Injectable()
export class SubmitToJobBoardsActionDataFacade {
  private readonly offerJobBoardStoreService = inject(OfferJobBoardStoreService);
  private readonly jobTemplatesJobBoardStoreService = inject(JobTemplatesJobBoardStoreService);

  public getJobBoards(jobId: number, jobKind: JobKind): Observable<JobBoard[]> {
    if (jobKind === JobKind.Job) {
      this.offerJobBoardStoreService.fetchOfferJobBoards(jobId);
      return this.offerJobBoardStoreService
        .getOfferJobBoards(jobId)
        .pipe(map(jobBoards => this.filterValidJobBoards(jobBoards)));
    }
    if (jobKind === JobKind.JobTemplate) {
      this.jobTemplatesJobBoardStoreService.fetchJobTemplatesJobBoards(jobId);
      return this.jobTemplatesJobBoardStoreService
        .getJobTemplatesJobBoards(jobId)
        .pipe(map(jobBoards => this.filterValidJobBoards(jobBoards)));
    }
    return of([]);
  }

  public jobBoardRequiresCredentials(jobBoard: JobBoard): boolean {
    return jobBoardRequiresCredentials(jobBoard);
  }

  private filterValidJobBoards(jobBoards: JobBoard[]): JobBoard[] {
    return jobBoards.filter(
      jobBoard =>
        !jobBoard.autoPosting &&
        !jobBoard.customIntegration &&
        (!jobBoard.validation || jobBoard.validation.valid),
    );
  }
}
